import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['subject', 'hint'];

  connect () {
    this.toggleHint();
  }

  toggleHint () {
    if (!this.hasSubjectTarget) return;

    const selectedValue = this.subjectTarget.value?.trim();

    this.hintTargets.forEach((hint) => {
      const matches = hint.dataset.subjectLabel?.trim() === selectedValue;
      hint.hidden = !matches;
    });
  }
}
